import { openBlock as e, createElementBlock as t, createElementVNode as o } from "vue";
const l = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, a = /* @__PURE__ */ o("path", { d: "M24 2.88a21.12 21.12 0 1 0 0 42.24 21.12 21.12 0 0 0 0-42.24Zm10.18 28.589a.96.96 0 0 1 0 1.358l-1.358 1.359a.96.96 0 0 1-1.353 0l-7.47-7.47-7.468 7.47a.96.96 0 0 1-1.353 0l-1.359-1.359a.96.96 0 0 1 0-1.358L21.283 24l-7.464-7.464a.96.96 0 0 1 0-1.358l1.358-1.359a.96.96 0 0 1 1.354 0L24 21.288l7.469-7.469a.96.96 0 0 1 1.353 0l1.359 1.359a.96.96 0 0 1 0 1.358L26.717 24l7.464 7.469Z" }, null, -1), n = [
  a
];
function c(r, s) {
  return e(), t("svg", l, n);
}
const _ = { render: c };
export {
  _ as default,
  c as render
};
//# sourceMappingURL=close-circle-fill.svg.mjs.map
